import { render, staticRenderFns } from "./exhibition-activity-list.vue?vue&type=template&id=dd557ce6&scoped=true&"
import script from "./exhibition-activity-list.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-list.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-list.vue?vue&type=style&index=0&id=dd557ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd557ce6",
  null
  
)

export default component.exports